<template>
    <div class="bg-F5F7FA">
        <tool-bar class="bg-FFFFFF" title="Add bank card"></tool-bar>
        <div class="bg-FCF7F7 h-35 flex-h flex-v-center padding-h-10 font-bold font-13 color-FF7171">
            <img class="w-20 h-20" src="../../assets/icon_tips.png">
            <div class="margin-l-10 wrap-card">
                <ul class="cards">
                    <li>{{bankTips}}</li>
                    <li>{{bankTips}}</li>
                </ul>
            </div>
        </div>
        <div style="margin: 10px; padding-bottom: 25px;" class="bg-FFFFFF radius-15 padding-h-20">
            <div class="h-60 flex-h flex-v-center font-bold font-18 color-14171B">
                <img class="h-27 w-27" src="../../assets/icon_bank.png">
                <span class="margin-l-10">Bank card information</span>
            </div>
            <div class="h-line-E6E8EB"></div>

            <div class="margin-t-20">
                <div class="font-16 font-bold color-14171B">Card Number</div>

                <div class="bg-F7F9FC radius-8 margin-t-10 flex-h flex-v-center" style="height: 70px;">
                    <label class="w-p-100 flex-h flex-v-center padding-h-15">
                        <input class="w-p-100 input-none-border font-bold color-14171B font-16"
                               type="number"
                               v-model="cardNumber"
                               placeholder="Please enter the card number">
                    </label>
                </div>
            </div>

            <div class="margin-t-25">
                <div class="font-16 font-bold color-14171B">Card Expiry</div>

                <div class="bg-F7F9FC radius-8 margin-t-10 flex-h flex-v-center" style="height: 70px;"
                     @click="showSelectDate = true">
                    <van-field v-model="selectedDate"
                               class="font-bold"
                               @field-placeholder-text-color="'red'"
                               style="background: transparent;font-size: 16px;"
                               readonly placeholder="MM/YY">

                    </van-field>
                </div>
            </div>

            <div class="margin-t-25">
                <div class="font-16 font-bold color-14171B">Card Cvv</div>

                <div class="bg-F7F9FC radius-8 margin-t-10 flex-h flex-v-center" style="height: 70px;">
                    <label class="w-p-100 flex-h flex-v-center padding-h-15">
                        <input class="w-p-100 input-none-border font-bold color-14171B font-16"
                               type="number"
                               v-model="cvv"
                               oninput="value = value.length > 3 ? value.slice(0,3):value"
                               placeholder="Please enter">
                    </label>
                </div>
            </div>
        </div>

        <span class="radius-15 bg-D9EEFF margin-10 font-15
                h-65 font-bold color-5AB2F9 padding-l-15 flex-v flex-h-center flex-v-center">
                    Please pay ₦20 to verify that the bank card is available.
                </span>

        <van-overlay :show="showTips">
            <div class="flex-h flex-v-center flex-h-center h-p-100">
                <div class="radius-25 bg-FFFFFF flex-v flex-v-center w-325">
                    <div class="margin-t-41 font-bold font-24 color-0B0D08">Card Binding Prom</div>
                    <div class="margin-t-30 font-16 font-bold color-888F99">
                        <div>
                            Please make sure your bank card is
                        </div>
                        <div class="margin-t-10">
                            authorized for online transaction.
                        </div>
                        <div class="margin-t-30">
                            You can confirm this by contacting
                        </div>

                        <div class="margin-t-10">
                            your bank or activating it through
                        </div>

                        <div class="margin-t-10">
                            the bank's mobile app.
                        </div>
                    </div>

                    <div class="margin-t-8 color-FFFFFF font-bold w-p-100 flex-h flex-h-center padding-30">
                        <van-button color="linear-gradient(to right,#1093FF, #69BBFF)"
                                    style="width: 280px; height:55px;border-radius: 8px;font-size: 19px;"
                                    @click="closeTips()">
                            Got it
                        </van-button>
                    </div>
                </div>
            </div>
        </van-overlay>


        <van-overlay :show="showBindFailed">
            <div class="flex-h flex-v-center flex-h-center h-p-100">
                <div class="flex-v flex-v-center w-325">
                    <div class="h-110 w-p-100 linear-gradient-h-EE4747-to-F78B8B"
                         style="border-top-left-radius: 25px;border-top-right-radius: 25px;text-align: center;position: relative;display: block">
                        <img src="../../assets/icon_fail.png" class="h-106 w-109 margin-t-10">
                        <div style="position: absolute;top:30%;text-align: center;width: 100%">
                            <div class="font-21 font-bold color-FFFFFF">Add failed</div>
                            <div class="margin-t-16 font-16 font-bold color-FFFFFF">{{formatCurrentTimeStamp()}}</div>
                        </div>
                    </div>
                    <div class="h-80 bg-FFFFFF w-p-100 flex-h flex-v-center"
                         style="border-bottom-left-radius: 25px;border-bottom-right-radius: 25px;">
                        <span class="font-bold font-15 color-47494A padding-h-20">
                            Reason: Bank card binding failed, please try again or change the card!
                        </span>
                    </div>

                    <div class="margin-t-20 color-FFFFFF font-bold w-p-100 flex-h flex-h-center">
                        <van-button color="linear-gradient(to right,#EE4747, #F78B8B)"
                                    style="width: 325px; height:55px;border-radius: 25px;font-size: 19px;"
                                    @click="showBindFailed = false">
                            Add again
                        </van-button>
                    </div>
                </div>
            </div>
        </van-overlay>


        <van-popup v-model="showSelectDate" position="bottom" class="font-bold">
            <van-datetime-picker
                    v-model="currentDate"
                    type="year-month"
                    :min-date="minDate"
                    :max-date="maxDate"
                    @confirm="confirmDate()"
                    @cancel="cancelDate()"
                    visible-item-count="5"
                    :formatter="formatter">
                <template #title>
                    <span class="font-19 font-bold">Select Date</span>
                </template>
                <template #cancel>
                    <span class="font-19 font-bold color-888F99">Cancel</span>
                </template>

                <template #confirm>
                    <span class="font-19 font-bold color-1477FD">Confirm</span>
                </template>
            </van-datetime-picker>
        </van-popup>

        <van-popup v-model="showOtp" position="bottom">
            <div class="bg-FFFFFF flex-v flex-v-center padding-b-20">
                <div class="font-21 font-bold color-14171B margin-t-30">OTP</div>
                <div class="font-16 font-bold color-47494A margin-t-19">Please enter your OTP</div>

                <sms_code_input class="margin-t-35" v-model="optCode" :number="6"></sms_code_input>

                <div class="margin-t-41 color-FFFFFF font-bold">
                    <van-button style="width: 340px; height:55px;border-radius: 8px;font-size: 19px;"
                                color="linear-gradient(to right,#1093FF, #69BBFF)"
                                :disabled="optCode.length !== 6"
                                @click="submitOpt()"
                                block>
                        Confirm
                    </van-button>
                </div>
            </div>
        </van-popup>


        <van-popup v-model="showPIN" position="bottom">
            <div class="bg-FFFFFF flex-v flex-v-center padding-b-20">
                <div class="font-21 font-bold color-14171B margin-t-30">PIN</div>
                <div class="font-16 font-bold color-47494A margin-t-19">Please enter your PIN code</div>

                <sms_code_square_input class="margin-t-35" v-model="pinCode" :number="4"></sms_code_square_input>

                <div class="margin-t-41 color-FFFFFF font-bold">
                    <van-button style="width: 340px; height:55px;border-radius: 8px;font-size: 19px;"
                                color="linear-gradient(to right,#1093FF, #69BBFF)"
                                :disabled="pinCode.length !== 4"
                                @click="submitPin()"
                                block>
                        Confirm
                    </van-button>
                </div>
            </div>
        </van-popup>

        <div class="bg-FFFFFF h-71 flex-v flex-h-center" style="position: fixed;bottom: 0;width: 100%">
            <div class="padding-h-15">
                <van-button style="font-size: 19px;border-radius: 8px;height: 55px;"
                            color="linear-gradient(to right,#1093FF, #69BBFF)"
                            @click="showConfirmTips()"
                            block>
                    Pay NGN 20
                </van-button>
            </div>
        </div>
    </div>
</template>

<script>
    import sms_code_input from "@/components/sms_code_input";
    import sms_code_square_input from "@/components/sms_code_square_input";
    import format from "@/utils/tools";

    export default {
        name: "bind_bank_card",
        components: {sms_code_square_input, sms_code_input},
        data() {
            return {
                showBindFailed: false,
                showTips: false,
                showOtp: false,
                showPIN: false,
                showSelectDate: false,
                currentDate: new Date(),
                selectedDate: '',
                minDate: new Date(2000, 0, 1),
                maxDate: new Date(2100, 11, 31),
                optCode: '',
                pinCode: '',
                cardNumber: '',
                cvv: '',
                bankTips: 'Tips: Adding Guaranty Trust Bank\'s card is easier to pass the review.',
                bankModel: {
                    proxyId: 0,
                    status: 0
                }
            }
        },
        mounted() {
            this.getBankTips()
        },
        beforeRouteEnter(to, from, next) {
            // 添加背景色
            document.querySelector('body').setAttribute('style', 'background-color:#F5F7FA')
            next()
        },
        beforeRouteLeave(to, from, next) {
            //去除背景色
            document.querySelector('body').setAttribute('style', '')
            next()
        },
        methods: {
            showConfirmTips() {
                this.showTips = true
            },
            closeTips() {
                this.showTips = false
                this.bindCard()
            },
            formatter(type, val) {
                if (type === 'year') {
                    return `${val}Y`;
                } else if (type === 'month') {
                    return `${val}M`;
                }
                return val;
            },
            confirmDate() {
                this.selectedDate = format.formatDateMMYY(this.currentDate)
                this.showSelectDate = false
            },
            cancelDate() {
                this.showSelectDate = false
            },
            bindCard() {
                if (this.cardNumber === '') {
                    this.$toast('Bank number cannot be empty!')
                    return
                }
                if (this.selectedDate === '') {
                    this.$toast('Card expiry cannot be empty!')
                    return;
                }
                if (this.cvv === '') {
                    this.$toast('Cvv cannot be empty!')
                    return;
                }
                this.$showLoading()
                let params = {
                    bankNumber: this.cardNumber,
                    cvv: this.cvv,
                    expiryMonth: this.selectedDate.substring(0, 2),
                    expiryYear: this.selectedDate.substring(3, 5),
                    pin: this.pin,
                    proxyId: this.bankModel.proxyId
                }
                this.$request.bindCard(params)
                    .then((res) => {
                        this.$hideLoading()
                        this.handleBindCardResult(res)
                    })
                    .catch(() => {
                        this.$hideLoading()
                    })
            },
            handleBindCardResult(res) {
                this.bankModel = res
                //绑卡成功
                if (res.status === 3) {
                    this.$router.push({
                        path: 'pay_result',
                        query: {
                            type: 1,
                            id: res.id
                        }
                    })
                } else if (res.status === 2) { //跳url
                    this.$router.push({
                        path: 'third_page',
                        query: {
                            type:'bindCard',
                            url: res.url
                        }
                    })
                } else if (res.status === 0) { //验证pin
                    this.showPIN = true
                } else if (res.status === 1) {//发送otp
                    this.showOtp = true
                } else {
                    this.showBindFailed = true
                }
            },
            getBankTips() {
                let params = {
                    type: 'HCASH_BANK_TIPS'
                }
                this.$request.getAppConfigType(params)
                    .then((res) => {
                        this.bankTips = res
                    }).catch(() => {

                })
            },
            submitPin() {
                this.showPIN = false
                if (this.bankModel.proxyId === 5) {
                    //提交PIN
                    this.$showLoading()
                    let params = {
                        pin: this.pinCode,
                        id: this.bankModel.id,
                        proxyId: this.bankModel.proxyId
                    }
                    this.$request.submitPin(params)
                        .then((res) => {
                            this.$hideLoading()
                            this.handleBindCardResult(res)
                        })
                        .catch(() => {
                            this.$hideLoading()
                        })
                } else if (this.bankModel.proxyId === 6) {
                    //重新执行绑定操作
                    this.bindCard()
                }
            },
            submitOpt() {
                this.showOtp = false
                //提交opt
                this.$showLoading()
                let params = {
                    opt: this.optCode,
                    id: this.bankModel.id,
                    proxyId: this.bankModel.proxyId
                }
                this.$request.submitOpt(params)
                    .then((res) => {
                        this.$hideLoading()
                        this.handleBindCardResult(res)
                    })
                    .catch(() => {
                        this.$hideLoading()
                    })
            },
            formatCurrentTimeStamp() {
                return format.formatDateHHmmDDMMYYYY(new Date())
            }
        },
    }
</script>

<style scoped>
    .wrap-card {
        margin: 20px auto;
        width: 400px;
        height: 200px;
        overflow: hidden;
    }

    ul {
        width: 800px;
    }

    li {
        float: left;
        width: 400px;
        height: 100%;
        line-height: 200px;
    }

    .cards {
        animation: Carousel 12s linear infinite;
        animation-delay: 3s;
        position: relative;
    }

    @keyframes Carousel {
        from {
            left: 0;
        }
        to {
            left: -400px;
        }
    }
</style>